{
  "pageTitle": "Donate Now",
  "weBelieve": "We believe that for",
  "everyTalented": "every talented student,",
  "anOpportunity": "there is an opportunity",
  "foundationsTitle1": "We’re supported by",
  "foundationsTitle2": "international non-profit",
  "foundationsTitle3": "foundations",
  "foundationsDescription1": "We are providing an opportunity for donors to transform children's lives who show great academic and leadership potential by giving them access to a first-rate education.",
  "foundationsDescription2": "Manara school donors can help level the playing field for less privileged kids in Egypt by providing the advantage of a college preparatory program that will set them up for success in university and beyond.",
  "donateNow": "Donate Now",
  "donationsError": "Failed to get donations data",
  "ourMissionTitle1": "Maximizing leadership potential to develop",
  "ourMissionTitle2": "our society’s future leaders",
  "ourMissionLink": "About Our Mission",
  "academicStructureTitle1": "We support an international College-Prep",
  "academicStructureTitle2": "Curriculum with Room for Exploration",
  "academicStructureLink": "Academic Structure",
  "donateConfirm": "Donate",
  "donationAmount": "Donate Amount",
  "donationAmountRequired": "Donation amount is required",

  "paymentMethod": "Payment Method",
  "paymentMethodDescription": "We offer secure and convenient payment options to ensure a smooth transaction experience",
  "byCreditCard": "By Credit Card",
  "byWireTransfer": "By Wire Transfer",

  "donateViaWireTransfer": "Donate via Wire Transfer",
  "donateViaWireTransferDescription":"If you would like to donate via wire transfer, please email",
  "donateViaWireTransferDescription2": ", and we will send you the wiring instructions.",

  "firstNameLabel": "First Name",
  "firstNamePlaceholder": "Mohamed",
  "firstNameError": "First Name is required!",
  "lastNameLabel": "Last Name",
  "lastNamePlaceholder": "Ahmed",
  "lastNameError": "Last Name is required!",
  "emailLabel": "Email",
  "emailPlaceholder": "example@example.com",
  "emailError": "Email should be ex@example.com",
  "emailRequired": "Email is required!",
  "phoneNumberLabel": "Phone Number",
  "phoneNumberPlaceholder": "010 000 000 00",
  "phoneNumberRequired": "Phone Number is required",
  "applyHere": "Apply Here",

  "addressRequired": "Address is required",
  "cityRequired": "City is required",
  "countryRequired": "Country is required",
  "zipCodeRequired": "Postal Code is required",
  "stateRequired": "State is required",
  "addressLabel": "Address",
  "addressPlaceholder": "Address",
  "cityLabel": "City",
  "cityPlaceholder": "City",
  "countryLabel": "Country",
  "countryPlaceholder": "Country",
  "zipCodeLabel": "Postal Code",
  "zipCodePlaceholder": "Postal Code",
  "stateLabel": "State",
  "statePlaceholder": "State"
}
